import React from 'react';
import styled from 'styled-components';

const NumberOfBlocks = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  color: ${props => props.color};
`;

export default NumberOfBlocks;
